'use-client';
import * as React from 'react';
import type { AccordionProps } from '../Accordion.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Accordion: React.FC<AccordionProps> = props => {
  return <TPAGallery {...props}></TPAGallery>;
};

export default Accordion;
